export const TeamRoles = {
  ADMIN: "admin",
  EDITOR: "editor",
} as const;

export const TeamPermissions = {
  VIDEO_VIEW: "video:view",
  VIDEO_EDIT: "video:edit",
  BILLING_EDIT: "billing:edit",
  TEAM_EDIT: "team:edit",
} as const;

export type TeamRole = (typeof TeamRoles)[keyof typeof TeamRoles];
export type TeamPermission =
  (typeof TeamPermissions)[keyof typeof TeamPermissions];

export const teamRolePermissions: Record<TeamRole, TeamPermission[]> = {
  [TeamRoles.ADMIN]: [
    TeamPermissions.VIDEO_VIEW,
    TeamPermissions.VIDEO_EDIT,
    TeamPermissions.BILLING_EDIT,
    TeamPermissions.TEAM_EDIT,
  ],
  [TeamRoles.EDITOR]: [TeamPermissions.VIDEO_VIEW, TeamPermissions.VIDEO_EDIT],
};
